import React from "react";
import DownloadIcon from "../icons/Download.js";
import PlusIcon from "../icons/Plus.js";
import MinusIcon from "../icons/Minus.js";
import SendIcon from "../icons/Send.js";
import PauseIcon from "../icons/Pause.js";
import PlayIcon from "../icons/Play.js";
import UsersIcon from "../icons/Users.js";

const iconMap = {
  download: DownloadIcon,
  plus: PlusIcon,
  minus: MinusIcon,
  send: SendIcon,
  pause: PauseIcon,
  play: PlayIcon,
  users: UsersIcon,
};

const Icon = ({ name, className, ...rest }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found.`);
    return null; // Or a default fallback icon
  }

  return <IconComponent className={className} {...rest} />;
};

export default Icon;
